import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
  email: "contact@rivierahostcollection.com",
  phone: "+33 6 00 00 00 00",
  instagram: "https://instagram.com/rivierahostcollection",
  whatsapp: "",
  city: "Cannes / Le Cannet – Côte d’Azur",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings({ ...FALLBACK, ...r.data })).catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext) || FALLBACK;
